export const TOKEN_HEADER: string = 'X-Auth-Token';

export const TOKEN_HEADER_USERNAME: string = 'X-Username';

export const TOKEN_HEADER_PASSWORD: string = 'X-Password';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/constants/header.names.ts